import BigNumber from 'bignumber.js'

import { SwapDetails } from '@root/entities/order/model'
import { TxHash } from '@root/entities/transaction'

import type { TradeApi } from '@root/shared/api'

type Dto = TradeApi.LimitOrderDto['swaps'][number]

export type LimitOrderSwap = {
  txHash: TxHash
  status: Dto['status']
  tokenIn: string
  tokenOut: string
  swapDetails?: SwapDetails.SwapDetails
  createdAt: Date
  rollingStats: {
    averageBuyMarketCap: BigNumber
    averageSellMarketCap: BigNumber
    averageBuyPrice: BigNumber
    averageSellPrice: BigNumber
    allTimeTokenAmount: BigNumber
  }
  pnl: BigNumber
}

export const fromDto = (swap: Dto): LimitOrderSwap => {
  return {
    ...swap,
    txHash: TxHash(swap.txHash),
    swapDetails: swap.swapDetails
      ? SwapDetails.fromDto(swap.swapDetails)
      : undefined,
    createdAt: new Date(swap.createdAt),
    rollingStats: {
      averageBuyMarketCap: BigNumber(swap.rollingStats.averageBuyMarketCap),
      averageSellMarketCap: BigNumber(swap.rollingStats.averageSellMarketCap),
      averageBuyPrice: BigNumber(swap.rollingStats.averageBuyPrice),
      averageSellPrice: BigNumber(swap.rollingStats.averageSellPrice),
      allTimeTokenAmount: BigNumber(swap.rollingStats.allTimeTokenAmount),
    },
    pnl: BigNumber(swap.pnl),
  }
}
